export var CardHeight = '270px';
export var CardMinWidth = '254px';
export var CardMaxWidth = '368px';
export var CardPreviewHeight = '155px';
export var CardHeaderHeight = '32px';
//# sourceMappingURL=StyleConstants.js.map